module.exports = __webpack_public_path__ + "img/testimonial-avatar.c7173a36.jpg";